<template>
  <span class="text-primary" v-if="live_player.id"
    >{{ pool_name }} : {{ unsold_in_live_pool }}/{{
      players_in_live_pool
    }}</span
  >
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, watchEffect, computed } from "vue";
import { useStore } from "@/store/index";
const store = useStore();
const auction = ref({});
const all_pools = ref([]);
const live_player = ref({});
const all_players = ref([]);

onMounted(() => {
  setTimeout(() => {
    fetchAuction();
    fetchPools();
    fetchAllPlayers();
  }, 1000);
});
const fetchAllPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_players.value = players;
  setupPlayersListner();
};
const setupPlayersListner = () => {
  const channels = supabase
    .channel("unsold-players-all-players-custom-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "players",
        filter: `auction_id=eq.${store.live_auction}`,
      },
      (payload) => {
        //console.log("Change received!", payload);
        const index = all_players.value.findIndex(
          (obj) => obj.id === payload.new.id
        );
        if (index) {
          all_players.value = all_players.value.filter(
            (player) => player.id !== payload.new.id
          );
          all_players.value.push(payload.new);
        }
      }
    )
    .subscribe();
};
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
  setupAuctionListner();
};
const setupAuctionListner = () => {
  const channels = supabase
    .channel("bidding-team-unsold-players-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "auctions" },
      (payload) => {
        console.log("Change received!", payload);
        if (payload.new.id == store.live_auction) {
          auction.value = payload.new;
        }
      }
    )
    .subscribe();
};
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_pools.value = pools;
};
const fetchLivePlayer = async (player_id) => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("id", player_id);
  live_player.value = players[0];
};
watchEffect(() => {
  if (auction.value.live_player_id) {
    fetchLivePlayer(auction.value.live_player_id);
  }
});

const players_in_live_pool = computed(() => {
  var player_count = 0;
  if (live_player.value.id) {
    all_players.value.forEach((p) => {
      if (p.pool_id == live_player.value.pool_id) {
        player_count++;
      }
    });
  }
  return player_count;
});
const unsold_in_live_pool = computed(() => {
  var unsold = 0;
  if (live_player.value.id) {
    all_players.value.forEach((p) => {
      if (p.pool_id == live_player.value.pool_id && !p.team_id) {
        unsold++;
      }
    });
  }
  return unsold;
});
const pool_name = computed(() => {
  var name = "";
  if (live_player.value.id) {
    all_pools.value.forEach((p) => {
      if (p.id == live_player.value.pool_id) {
        name = p.name;
      }
    });
  }
  return name;
});
</script>
